<template>
 <vue-form @submit="submit"
           :disabled="isFormDisabled"
           :form="form"
           :action="action"
           :status="status">
    <section class="form-section">
      <header>
        <h3>Client</h3>
      </header>
      <div>
        <form-group label="Type">
          <p class="-m-1">
            <vue-radio class="m-1"
                       label="personal"
                       :disabled="isFormDisabled"
                       v-model="selectedType">Particulier
            </vue-radio>
            <vue-radio class="m-1"
                       label="company"
                       :disabled="isFormDisabled"
                       v-model="selectedType">Professionnel
            </vue-radio>
          </p>
        </form-group>

        <form-group v-if="selectedType !== 'company'"
                    class="md:w-1/2"
                    field="last_name"
                    label="Nom">
          <vue-input id="last_name" v-model="form.last_name" :disabled="isFormDisabled"/>
        </form-group>

        <form-group v-if="selectedType !== 'company'"
                    class="md:w-1/2"
                    field="first_name"
                    label="Prénom">
          <vue-input id="first_name" v-model="form.first_name" :disabled="isFormDisabled"/>
        </form-group>

        <form-group v-if="selectedType === 'company'"
                    class="md:w-1/2"
                    field="company_name"
                    label="Nom de la société">
          <vue-input id="company_name" v-model="form.company_name" :disabled="isFormDisabled"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Téléphone</h3>
        <p>
          Les champs ne sont pas obligatoires mais il est <strong>fortement
          recommandé</strong> de les renseigner.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="mobile_phone" label="Mobile">
          <vue-input type="tel"
                     id="mobile_phone"
                     v-model="form.mobile_phone"
                     placeholder="0600000000"
                     :disabled="isFormDisabled"/>
        </form-group>
        <form-group class="md:w-1/2" field="home_phone" label="Fixe">
          <vue-input type="tel"
                     id="home_phone"
                     placeholder="0555000000"
                     v-model="form.home_phone"
                     :disabled="isFormDisabled"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Adresse</h3>
        <p>
          L'adresse n'est pour le moment pas utilisée mais peut vous aider à identifier un client avec un homonyme.
        </p>
      </header>
      <div>
        <form-group field="address" label="Adresse">
          <vue-textarea id="address" v-model="form.address" :disabled="isFormDisabled"/>
        </form-group>
        <form-group class="md:w-1/2" field="postcode" label="Code postal">
          <vue-input id="postcode" v-model="form.postcode" :disabled="isFormDisabled"/>
        </form-group>
        <form-group class="md:w-1/2" field="city" label="Ville">
          <vue-input id="city" v-model="form.city" :disabled="isFormDisabled"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Email</h3>
        <p>
          L'adresse email n'est pour le moment pas utilisée mais pourrait l'être dans de nouvelles fonctionnalités.
        </p>
      </header>
      <div>
        <form-group class="md:w-2/3" field="email" label="Email">
          <vue-input type="email" id="email" v-model="form.email" :disabled="isFormDisabled"/>
        </form-group>
      </div>
    </section>
    <section class="form-section" v-if="isUpdateForm && canDelete">
      <header>
        <h3>Zone de danger</h3>
        <p>
          Le client sera <strong>définitivement supprimé</strong> et ne pourra pas être restauré.
          Toutes ses commandes seront aussi supprimées.
        </p>
      </header>
      <div>
        <form-group label="Voulez-vous supprimer définitivement ce client ?">
          <confirm-button @confirmed="destroy"
                          popover-type="popover-top-left sm:popover-right"
                          btn-class="btn-primary btn-outline"
                          btn-confirm-text="Supprimer"
                          :disabled="isFormDisabled"
                          :status="statusDestroy">Supprimer le client</confirm-button>
        </form-group>
      </div>
    </section>
  </vue-form>
</template>

<script>
import Form from 'form-backend-validation';
import form from '../../mixins/form';

export default {
  mixins: [form],
  data() {
    return {
      selectedType: 'personal',
      form: new Form({
        first_name: '',
        last_name: '',
        company_name: '',
        mobile_phone: '',
        home_phone: '',
        address: '',
        postcode: '',
        city: '',
        email: '',
      }),
    };
  },

  watch: {
    'form.company_name': function (value) {
      this.selectedType = value ? 'company' : 'personal';
    },
  },
};
</script>